module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_efo-cad0d3f251d6cb2c590c1e38a11bb28c.svg";